export default __webpack_public_path__ + "static/media/provesional_restoration_lower_21_2@2x.75391612.png";